import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Transition as _Transition, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-228d8fcb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Bug report", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Timeline", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "My Recipes", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Admin", -1))
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = { class: "dropdown-nav" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Timeline", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "My Recipes", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Admin", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Bug report", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentReportIcon = _resolveComponent("DocumentReportIcon")!
  const _component_ClockIcon = _resolveComponent("ClockIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BookOpenIcon = _resolveComponent("BookOpenIcon")!
  const _component_CogIcon = _resolveComponent("CogIcon")!
  const _component_UserCircleIcon = _resolveComponent("UserCircleIcon")!
  const _component_MenuIcon = _resolveComponent("MenuIcon")!
  const _component_BugReportModalContent = _resolveComponent("BugReportModalContent")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", {
      id: "header",
      class: _normalizeClass({ 'scrolled-nav': _ctx.scrolledNav })
    }, [
      _createElementVNode("nav", null, [
        _withDirectives(_createElementVNode("ul", _hoisted_1, [
          _createElementVNode("li", {
            class: "align-left link",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.bugReportClicked && _ctx.bugReportClicked(...args)))
          }, [
            _createVNode(_component_DocumentReportIcon),
            _hoisted_2
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/Timeline",
              class: "link"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ClockIcon),
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/Recipes",
              class: "link"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_BookOpenIcon),
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          (_ctx.isAdmin)
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: "/Admin",
                  class: "link"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CogIcon),
                    _hoisted_6
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/Profile",
              class: "link"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_UserCircleIcon),
                _createElementVNode("span", null, _toDisplayString(_ctx.contextUser.displayName), 1)
              ]),
              _: 1
            })
          ])
        ], 512), [
          [_vShow, !_ctx.mobile]
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createVNode(_component_MenuIcon, {
            onClick: _ctx.toggleMobileNav,
            class: _normalizeClass({ 'icon-active': _ctx.mobileNav })
          }, null, 8, ["onClick", "class"]), [
            [_vShow, _ctx.mobile]
          ])
        ]),
        _createVNode(_Transition, { name: "mobile-nav" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("ul", _hoisted_8, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _ctx.closeMobileNav,
                  to: "/Timeline",
                  class: "link"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ClockIcon),
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _ctx.closeMobileNav,
                  to: "/Recipes",
                  class: "link"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_BookOpenIcon),
                    _hoisted_10
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              (_ctx.isAdmin)
                ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                    _createVNode(_component_router_link, {
                      onClick: _ctx.closeMobileNav,
                      to: "/Admin",
                      class: "link"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_CogIcon),
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _ctx.closeMobileNav,
                  to: "/Profile",
                  class: "link"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_UserCircleIcon),
                    _createElementVNode("span", null, _toDisplayString(_ctx.contextUser.displayName), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createElementVNode("li", {
                class: "link",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.bugReportClicked && _ctx.bugReportClicked(...args)))
              }, [
                _createVNode(_component_DocumentReportIcon),
                _hoisted_13
              ])
            ], 512), [
              [_vShow, _ctx.mobileNav]
            ])
          ]),
          _: 1
        })
      ])
    ], 2),
    _createVNode(_component_Modal, {
      "is-open": _ctx.bugReportModal,
      onOnCloseClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.bugReportModal = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_BugReportModalContent, {
          onOnSubmit: _cache[2] || (_cache[2] = ($event: any) => (_ctx.bugReportModal = false))
        })
      ]),
      _: 1
    }, 8, ["is-open"])
  ], 64))
}